<template>
  <!-- @license lucide-static v1.8.0 - ISC -->
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 7h10v10" />
    <path d="M7 17 17 7" />
  </svg>
</template>

<script>
export default { name: 'LucideArrowUpRight' };
</script>
